// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"6954f9de","57":"01367e57","102":"abad5ce9","165":"05655066","180":"7e5eb27f","203":"3f1553c9","213":"ea19df95","240":"e3ee0c11","253":"1d13c033","283":"543046c5","858":"ad1837e4","859":"f0a752e4"}[chunkId] + ".chunk.js";
};